import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MultiSourceTab from '../../../../Components-2025/IR/MultiSourceTab';
import { apiServices } from './utils/twoStatementServices';
import { messages } from '../../../../common/messages';
import appRoutes from '../../../../routes/exams/gmat-focus/app-routes';
import { examNameAccordingToDB, QUESTION_TYPE } from '../../../../common/constant';

class GMATTab extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  redirectTo = (path) => {
    const { router } = this.context;
    const { chapterid, readingid, subscription, reading } = this.props.params;

    const routes = {
      question: appRoutes.QUESTION_BANK_LIST_QUE.replace(':chapter_no', chapterid)
        .replace(':id', readingid)
        .replace(':subscriptionstatus', parseInt(subscription, 10) ? 'paid' : 'free')
        .replace(':reading', reading),

      reading: appRoutes.QUESTION_BANK_READING.replace(':id', chapterid),
    };

    if (routes[path]) {
      router.push({ pathname: routes[path] });
    }
  };
  handleChangeParams = (value) => {
    const { index, question_id } = value;
    const { chapterid, readingid, subscription, reading } = this.props.params;
    this.context.router.push({
      pathname: appRoutes.TAB.replace(':chapterid', chapterid)
        .replace(':readingid', readingid)
        .replace(':subscription', subscription)
        .replace(':question_id', question_id)
        .replace(':offset', index)
        .replace(':reading', reading),
    });
  };

  render() {
    return (
      <div>
        <MultiSourceTab
          {...this.props}
          examName={examNameAccordingToDB.GMAT_FOCUS}
          apiServices={apiServices}
          questionType={QUESTION_TYPE.TAB_QUESTION}
          redirectTo={this.redirectTo}
          handleChangeParams={this.handleChangeParams}
        />
      </div>
    );
  }
}
export default GMATTab;



// WEBPACK FOOTER //
// ./src/views/GMATFocus/QuestionBank/SpecialQuestions/GMATTab.js